import { render } from "./DynamicForm.vue?vue&type=template&id=28cdf473&scoped=true&ts=true"
import script from "./DynamicForm.vue?vue&type=script&lang=ts"
export * from "./DynamicForm.vue?vue&type=script&lang=ts"

import "./DynamicForm.vue?vue&type=style&index=0&id=28cdf473&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28cdf473"]])

export default __exports__